module.exports = __webpack_public_path__ + "static/media/correct.7ffc3cb0.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/correct.wav
// module id = 389
// module chunks = 0